var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.396,
    height: 7.731,
    viewBox: "0 0 17.396 7.731",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.295,140.656l-3.866-3.523a.323.323,0,0,0-.352-.05.292.292,0,0,0-.191.292v2.255H.322a.31.31,0,0,0-.322.322v1.933a.31.31,0,0,0,.322.322H12.886v2.255a.3.3,0,0,0,.191.292.314.314,0,0,0,.352-.06l3.866-3.564a.329.329,0,0,0,.1-.242A.318.318,0,0,0,17.295,140.656Z",
    transform: "translate(0 -137.052)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.707be3717a42c99281bd819ebcebd257.svg";
export { ForwardRef as ReactComponent };